export const ACCOUNT_TYPE = "account_type";
export type EntityType = typeof ACCOUNT_TYPE;

export type EntityRef = {
  entity_type: EntityType;
  entity_id: string;
  counterparty_can_execute?: boolean;
};
